import { useEffect, useState } from 'react';

import Banner from '@/assets/banner/background.webp';
import PageBanner from '@/components/banner/PageBanner';
import { ContainerFluid } from '@/components/container/Container';
import { BodyLgHtml, H3 } from '@/components/ui/typography/Typography';
import { wrapIframe } from '@/utils/wrapIframeVideo';

import Seo from '@/components/seo/Seo';
import DetailSkeletonOneColumn from '@/components/skeleton/DetailSkeletonOneColumn';
import { ApiService } from '@/services/api.services';
import { Navigate } from 'react-router-dom';

export default function HistoryPages() {
  const SLUG = 'visi-misi';

  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchPage = async () => {
      try {
        const res = await ApiService.getAboutPageBySlug(SLUG);
        const data = res.data;
        if (!data || !data.content) {
          setPage(null);
          return;
        }

        const content = wrapIframe(data.content);

        if (isMounted) {
          setPage({
            ...data,
            content,
          });
        }
      } catch (error) {
        console.error(error);
        setPage(null);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchPage();

    return () => {
      isMounted = false;
    };
  }, [SLUG]);

  if (loading) {
    return (
      <>
        <PageBanner image={Banner} loading={loading} />
        <DetailSkeletonOneColumn />
      </>
    );
  }

  if (!page) {
    return <Navigate to="/404" replace />;
  }

  return (
    <>
      <Seo
        title="Visi Misi | Abdi Kerta Raharja"
        description="Visi Misi Koperasi Syariah Abdi Kerta Raharja."
        canonical="https://www.abdikertaraharja.co.id/tentang-kami/profil/visi-misi"
      />
      <div>
        <PageBanner
          title={page.title}
          description="Profil lengkap Koperasi Abdi Kerta Raharja dan perjalanan kami dalam memberikan pelayanan terbaik."
          image={Banner}
        />

        <ContainerFluid className="py-16">
          <H3>{page.title}</H3>

          <BodyLgHtml className="py-5 text-xs md:text-sm leading-relaxed" html={page.content} />
        </ContainerFluid>
      </div>
    </>
  );
}
